/**
 * Returns true when the current page is rendered inside an iframe.
 * Used to select popup vs redirect auth flows — redirects break iframe navigation.
 */
export const isInIframe = () => window.self !== window.top;
